<template>
  <div class="empty-layout">
    <Sidebar />
    <Notifications />
    <slot />
  </div>
</template>

<script>
import Notifications from '../components/layouts/Notifications.vue';
import Sidebar from '../components/layouts/Sidebar.vue';

export default {
  name: 'EmptyLayout',
  components: {
    Notifications,
    Sidebar,
  },
};
</script>
